import tw from "tailwind-styled-components";
import { FaCoins, FaRupeeSign, FaMoneyBill } from "react-icons/fa";
import { IoIosArrowForward } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import Tooltip from "../Tooltip";
import { TbRoute } from "react-icons/tb";
import { FiPhoneCall } from "react-icons/fi";     // call follow-ups

const CollectionSummaryCard = ({ commissionStats, followUpStats, pipeline }) => {
    const navigate = useNavigate();

    return (
        <MainContainer>
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
                <Card>
                    <Header>
                        <IconWrapper><FaCoins size={20} className="text-gray-700" /></IconWrapper>
                        <Title>{'Commission'}</Title>
                    </Header>
                    <SubtitleValue className='cursor-pointer' onClick={() => navigate('/finance/collections')}>
                        <h1 className={`text-3xl font-semibold text-blue-600 tracking-tight`}>₹{commissionStats?.totalRecieved || 0}</h1>
                    </SubtitleValue>
                    <Subtitle className='group cursor-pointer' onClick={() => navigate('/finance/collections')}>
                        {'Total'}
                        <Arrow />
                    </Subtitle>
                    <StatsGrid>
                        <StatItem>
                            <StatNumber>₹{commissionStats?.todayRecieved || 0}</StatNumber>
                            <StatLabel>
                                Today's
                            </StatLabel>
                        </StatItem>
                        <StatItem className='group cursor-pointer' onClick={() => navigate('/revenue')}>
                            <StatNumber className='text-rose-500'>₹{commissionStats?.totalPending || 0}</StatNumber>
                            <StatLabel>
                                {'Dues Till Now'}
                                <Arrow />
                                {/* <IoIosArrowForward
                                    size={12}
                                    className="ml-1 mt-0.5"
                                /> */}
                            </StatLabel>
                        </StatItem>
                    </StatsGrid>
                    {/* <FooterText>{"Security in hand : ₹" + clientSummary?.securityInHand}</FooterText> */}
                </Card>

                {/* Expense */}
                <Card>
                    <Header>
                        <IconWrapper><FiPhoneCall size={20} className="text-gray-500" /></IconWrapper>
                        <Title>{'Follow Ups'}</Title>
                    </Header>
                    <SubtitleValue className='cursor-pointer' onClick={() => navigate('/deals/pipeline')}>
                        <h1 className={`text-3xl font-semibold text-orange-600 tracking-tight`}>{followUpStats?.today || 0}</h1>
                    </SubtitleValue>

                    <Subtitle className='group cursor-pointer'>
                        {'Actions Today'}
                        <Arrow />
                    </Subtitle>
                    <StatsGrid>
                        <StatItem className='group cursor-pointer' onClick={() => navigate('/deals/pipeline')}>
                            <StatNumber>{followUpStats?.ovedue || 0}</StatNumber>
                            <StatLabel>
                                {'Urgent'}
                                <Arrow />
                            </StatLabel>
                        </StatItem>
                        <StatItem className='group cursor-pointer' onClick={() => navigate('/deals/pipeline')}>
                            <StatNumber className='text-orange-400'>{followUpStats?.upcoming}</StatNumber>
                            <StatLabel>
                                {'Upcoming'}
                                <Arrow />
                            </StatLabel>
                        </StatItem>
                    </StatsGrid>
                    {/* <FooterText>{"Security paid to landlord : ₹" + expenseStats?.lifetimeSecurityPaid}</FooterText> */}
                </Card>

                {/* Income & Summary */}
                <Card>
                    <Header>
                        <IconWrapper><TbRoute size={20} className="text-gray-500" /></IconWrapper>
                        <Title>{'Pipeline/Deals'}</Title>
                    </Header>
                    <SubtitleValue>
                        <h1 className={`text-3xl font-semibold ${followUpStats > 0 ? 'text-green-600' : 'text-rose-600'} tracking-tight`}>{pipeline?.active}</h1>
                    </SubtitleValue>

                    <Subtitle>
                        {'Active Deals'}
                    </Subtitle>
                    <StatsGrid>
                        <StatItem>
                            <StatNumber>{pipeline?.inNegotiation || 0}</StatNumber>
                            <StatLabel>
                                {'Hot Deals'}
                            </StatLabel>
                        </StatItem>
                        <StatItem className='group cursor-pointer' onClick={() => navigate('/finance/refund')}>
                            <StatNumber>{pipeline?.atRisk}</StatNumber>
                            <StatLabel>
                                {'At Risk'}
                                <Arrow />
                                {/* <IoIosArrowForward
                                    size={12}
                                    className="ml-1 mt-0.5"
                                /> */}
                            </StatLabel>
                        </StatItem>
                    </StatsGrid>
                    {/* <FooterText className='group cursor-pointer flex text-blue-500 hover:text-blue-700 transition-colors' onClick={() => navigate("/income-expense")}>
                        {"Month-on-Month Summary"}
                        <Arrow />
                    </FooterText> */}
                </Card>

            </div>
        </MainContainer >
    );
};

// Styled Components
const MainContainer = tw.div`mt-6`;
const Card = tw.div`
  bg-white rounded-xl
  px-6 pt-5 pb-6
  shadow-[0_4px_14px_rgba(0,0,0,0.06)]
  transition-shadow duration-200
`;
const Header = tw.div`
  flex items-center gap-3
`;
const IconWrapper = tw.div`
  p-2 rounded-lg bg-gray-50 text-gray-500
`;
const Title = tw.h3`
  text-sm font-semibold text-gray-700 uppercase tracking-wide
`;
const SubtitleValue = tw.div`
  flex items-baseline gap-2 mt-4
`;
const Subtitle = tw.span`text-sm text-gray-500 flex items-center ${props => props.clickable ? 'cursor-pointer' : ''}`;
const StatsGrid = tw.div`grid md:grid-cols-2 grid-cols-1 mt-6 gap-6`;
const StatItem = tw.div`${props => props.clickable ? `cursor-pointer ` : ''}`;
const StatNumber = tw.h4`
  text-base font-medium text-gray-800
`;

const StatLabel = tw.span`
  text-sm text-gray-500 flex items-center ${props => props.clickable ? 'cursor-pointer' : ''}`;

const Arrow = tw(IoIosArrowForward)`
  text-gray-400 text-xs
  opacity-0 group-hover:opacity-100
  transition-opacity ml-1 mt-0.5
`;

const FooterText = tw.p`
  text-xs text-gray-400 mt-5 pt-3 border-t border-gray-100
`;

export default CollectionSummaryCard;
